import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InfiniteScrollModule } from '@epicuro-next/ataraxia/infinite-scroll';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { AtaraxiaPaginationLoaderModule } from '@epicuro-next/ataraxia/pagination-loader';
import { ProductCardTitleComponent } from '@epicuro-next/ataraxia/product-card';
import { PRODUCT_CARD_FEATURE_NAME } from '@epicuro-next/constants/rule-engine/product-card-rules';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { RuleEngineModule } from '@epicuro-next/platform/rule-engine';
import { ProductCardModule } from '@epicuro-next/product-card';
import { RecommendationPanelsModule } from '@epicuro-next/recommendation-panels';
import { ConfigStripStateModule } from '@epicuro-next/state/config-strip-state';
import { LetDirective } from '@ngrx/component';
import {
  MediaRelationsService,
  MediaRelationsSuggestStore,
} from 'data-media-relations';
import { SimilarProductsContainerComponent } from 'features-similar-products';

import { ProductsSearchListComponent } from './components/products-search-list/products-search-list.component';

@NgModule({
  imports: [
    CommonModule,
    ProductCardModule,
    InfiniteScrollModule,
    RuleEngineModule,
    ConfigStripStateModule,
    ConfigurationModule.forFeature(PRODUCT_CARD_FEATURE_NAME),
    AtaraxiaPaginationLoaderModule,
    LetDirective,
    RecommendationPanelsModule,
    MediaPreviewModule,
    SimilarProductsContainerComponent,
    ProductCardTitleComponent,
  ],
  declarations: [ProductsSearchListComponent],
  exports: [ProductsSearchListComponent],
  providers: [MediaRelationsSuggestStore, MediaRelationsService],
})
export class ProductsSearchListModule {}
